"use client";

import {motion, useMotionValue, useTransform, animate} from "framer-motion";
import  {useEffect} from "react";

export default function CountAnimation({
                                           number,
                                           className,
                                       }: {
    number: number;
    className?: string;
}) {
    // Start at 0, animate up to `number`
    const count = useMotionValue(0);

    // Round to the nearest integer, then apply Intl formatting
    const formattedCount = useTransform(count, (latest) =>
        new Intl.NumberFormat("de-DE").format(Math.round(latest))
    );

    useEffect(() => {
        const animation = animate(count, number, {duration: 2});
        return () => animation.stop();
    }, [count, number]);

    // Use `formattedCount` to display the final output
    return <motion.h4 className={className}>{formattedCount}</motion.h4>;
}
